// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__14aiF","inputLabel":"styles_inputLabel__3AA79","tab":"styles_tab__x0PMe","hidden":"styles_hidden__2b5N8"};